import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {MegaMenu} from './MegaMenu'
import {useIntl} from 'react-intl'
import {useAuth} from "../../../../app/modules/auth";
import InterfaceSection from "../../../../app/pages/Admin/interfaceSection/InterfaceSection";
import Menu from "../../../../app/pages/Admin/Menu/Menu";

export function MenuInner() {
    const intl = useIntl()
    const {currentUser} = useAuth();

    return (
        <>
            {currentUser?.roles?.includes('Admin') &&(
                <MenuItem title={intl.formatMessage({id: 'MENU.DASHBOARD'})} to='/dashboard'/>

            )}
            {/*<MenuItem title='Layout Builder' to='/builder'/>*/}
            <MenuInnerWithSub title='داشبورد' to='/crafted/account/overview' menuPlacement='bottom-start' menuTrigger='click'>
                <MenuItem
                    icon='/media/icons/duotune/general/gen051.svg'
                    to='/Disk/Calculate'
                    title='میز کار'
                />
                <MenuItem
                    icon='/media/icons/duotune/general/gen051.svg'
                    to='/crafted/account/overview'
                    title='اطلاعات کاربری'
                />
                <MenuItem
                    icon='/media/icons/duotune/general/gen051.svg'
                    to='/crafted/account/settings'
                    title='تنظیمات حساب کاربری'
                />
            </MenuInnerWithSub>
            <MenuItem

                to='/crafted/account/purchase'
                title='تمدید اشتراک'
            />
            <MenuItem

                to='/crafted/account/accounting'
                title='مالی'
            />
            <MenuInnerWithSub title='کارمندان' to='/crafted/account/overview' menuPlacement='bottom-start' menuTrigger='click'>
                <MenuItem
                    icon='/media/icons/duotune/general/gen051.svg'
                    to='/apps/Costumer-management/users'
                    title='مدیریت کارمندان'
                />
                <MenuItem
                    icon='/media/icons/duotune/general/gen051.svg'
                    to='/apps/Costumer-management/groupAdd'
                    title='افزودن دسته ای کارمندان'
                />
                <MenuItem
                    icon='/media/icons/duotune/general/gen051.svg'
                    to='/list/manage'
                    title='مدیریت لیست'
                />
            </MenuInnerWithSub>
            <MenuItem

                to='/apps/manufacury/manufacurys'
                title='مدیریت کارگاه ها'
            />


            <MenuItem

                to='/Disk/Lists'
                title='مدیریت دیسک ها '
            />
            <MenuItem

                to='/Tickets/Lists'
                title='پشتیبانی '
            />
            {currentUser?.roles?.includes('Admin') && (
                <MenuInnerWithSub to='/Admin' title='مدیریت سیستم' menuPlacement='bottom-start' menuTrigger='click'>
                    <MenuItem
                        icon='/media/icons/duotune/general/gen051.svg'
                        to='/Admin/ClientList'
                        title='مدیریت کاربران '
                    />
                    <MenuItem
                        icon='/media/icons/duotune/general/gen051.svg'
                        to='/Admin/Payments'
                        title='تراکنش های پرداخت '
                    />
                    <MenuItem
                        icon='/media/icons/duotune/general/gen051.svg'
                        to='/Admin/ZarinPalUnverified'
                        title='تراکنش های ناموفق زرین پال'
                    />
                    <MenuItem
                        icon='/media/icons/duotune/general/gen051.svg'
                        to='/Admin/EPayHistory'
                        title='تاریخچع تراکنش های اقتصاد نوین'
                    />
                    <MenuItem
                        icon='/media/icons/duotune/general/gen051.svg'
                        to='/Admin/Tickets'
                        title='مدیریت تیکت ها'
                    />
                    <MenuInnerWithSub
                        title='وب سایت '
                        to='/Admin/'
                        icon='/media/icons/duotune/general/gen022.svg'
                        hasArrow={true}
                        menuPlacement='left-start'
                        menuTrigger={`{default:'click', lg: 'hover'}`}
                    >
                        <MenuItem
                            icon='/media/icons/duotune/general/gen051.svg'
                            to='/Admin/Slider'
                            title='تنظیمات اسلایدر'
                        />
                        <MenuItem
                            icon='/media/icons/duotune/general/gen051.svg'
                            to='/Admin/SliderPage'
                            title=' اسلایدر'
                        />
<MenuItem
                            icon='/media/icons/duotune/general/gen051.svg'
                            to='/Admin/MobileSectioneList'
                            title=' MobileSectioneList'
                        />
<MenuItem
                            icon='/media/icons/duotune/general/gen051.svg'
                            to='/Admin/BaseConfig'
                            title=' BaseConfig'
                        />
<MenuItem
                            icon='/media/icons/duotune/general/gen051.svg'
                            to='/Admin/InterfaceSection'
                            title=' InterfaceSection'
                        />
                        <MenuItem
                            icon='/media/icons/duotune/general/gen051.svg'
                            to='/Admin/USerQuestionList'
                            title=' USerQuestionList'
                        />
<MenuItem
                            icon='/media/icons/duotune/general/gen051.svg'
                            to='/Admin/Menu'
                            title=' Menu'
                        />

                        <MenuInnerWithSub
                            title='پست '
                            to='/Admin/Post'
                            icon='/media/icons/duotune/general/gen022.svg'
                            hasArrow={true}
                            menuPlacement='left-start'
                            menuTrigger={`{default:'click', lg: 'hover'}`}
                        >
                            <MenuItem
                                icon='/media/icons/duotune/general/gen051.svg'
                                to='/Admin/Post'
                                title='مدیریت پست ها'
                            />
                            <MenuItem
                                icon='/media/icons/duotune/general/gen051.svg'
                                to='/Admin/PostType'
                                title='دسته بندی پست ها'
                            />
                        </MenuInnerWithSub>
                        <MenuItem
                            icon='/media/icons/duotune/general/gen051.svg'
                            to='/Admin/Pages'
                            title='مدیریت صفحه ها'
                        />
                        <MenuItem
                            icon='/media/icons/duotune/general/gen051.svg'
                            to='/Admin/Faqs'
                            title='سوالات رایج'
                        />
                    </MenuInnerWithSub>


                </MenuInnerWithSub>
            )}
            {/*<MenuInnerWithSub*/}
            {/*    title='Crafted'*/}
            {/*    to='/crafted'*/}
            {/*    menuPlacement='bottom-start'*/}
            {/*    menuTrigger='click'*/}
            {/*>*/}
            {/*    /!* PAGES *!/*/}
            {/*    <MenuInnerWithSub*/}
            {/*        title='Pages'*/}
            {/*        to='/crafted/pages'*/}
            {/*        icon='/media/icons/duotune/general/gen022.svg'*/}
            {/*        hasArrow={true}*/}
            {/*        menuPlacement='left-start'*/}
            {/*        menuTrigger={`{default:'click', lg: 'hover'}`}*/}
            {/*    >*/}
            {/*        <MenuInnerWithSub*/}
            {/*            title='Profile'*/}
            {/*            to='/crafted/pages/profile'*/}
            {/*            hasArrow={true}*/}
            {/*            hasBullet={true}*/}
            {/*            menuPlacement='left-start'*/}
            {/*            menuTrigger={`{default:'click', lg: 'hover'}`}*/}
            {/*        >*/}
            {/*            <MenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true}/>*/}
            {/*            <MenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true}/>*/}
            {/*            <MenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true}/>*/}
            {/*            <MenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true}/>*/}
            {/*            <MenuItem*/}
            {/*                to='/crafted/pages/profile/connections'*/}
            {/*                title='Connections'*/}
            {/*                hasBullet={true}*/}
            {/*            />*/}
            {/*        </MenuInnerWithSub>*/}
            {/*        <MenuInnerWithSub*/}
            {/*            title='Wizards'*/}
            {/*            to='/crafted/pages/wizards'*/}
            {/*            hasArrow={true}*/}
            {/*            hasBullet={true}*/}
            {/*            menuPlacement='left-start'*/}
            {/*            menuTrigger={`{default:'click', lg: 'hover'}`}*/}
            {/*        >*/}
            {/*            <MenuItem to='/crafted/pages/wizards/horizontal' title='Horizontal' hasBullet={true}/>*/}
            {/*            <MenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true}/>*/}
            {/*        </MenuInnerWithSub>*/}
            {/*    </MenuInnerWithSub>*/}

            {/*    /!* ACCOUNT *!/*/}
            {/*    <MenuInnerWithSub*/}
            {/*        title='Accounts'*/}
            {/*        to='/crafted/accounts'*/}
            {/*        icon='/media/icons/duotune/communication/com006.svg'*/}
            {/*        hasArrow={true}*/}
            {/*        menuPlacement='left-start'*/}
            {/*        menuTrigger={`{default:'click', lg: 'hover'}`}*/}
            {/*    >*/}
            {/*        <MenuItem to='/crafted/account/overview' title='Overview' hasBullet={true}/>*/}
            {/*        <MenuItem to='/crafted/account/settings' title='Settings' hasBullet={true}/>*/}
            {/*    </MenuInnerWithSub>*/}

            {/*    /!* ERRORS *!/*/}
            {/*    <MenuInnerWithSub*/}
            {/*        title='Errors'*/}
            {/*        to='/error'*/}
            {/*        icon='/media/icons/duotune/technology/teh004.svg'*/}
            {/*        hasArrow={true}*/}
            {/*        menuPlacement='left-start'*/}
            {/*        menuTrigger={`{default:'click', lg: 'hover'}`}*/}
            {/*    >*/}
            {/*        <MenuItem to='/error/404' title='Error 404' hasBullet={true}/>*/}
            {/*        <MenuItem to='/error/500' title='Error 500' hasBullet={true}/>*/}
            {/*    </MenuInnerWithSub>*/}

            {/*    /!* Widgets *!/*/}
            {/*    <MenuInnerWithSub*/}
            {/*        title='Widgets'*/}
            {/*        to='/crafted/widgets'*/}
            {/*        icon='/media/icons/duotune/general/gen025.svg'*/}
            {/*        hasArrow={true}*/}
            {/*        menuPlacement='left-start'*/}
            {/*        menuTrigger={`{default:'click', lg: 'hover'}`}*/}
            {/*    >*/}
            {/*        <MenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true}/>*/}
            {/*        <MenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true}/>*/}
            {/*        <MenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true}/>*/}
            {/*        <MenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true}/>*/}
            {/*        <MenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true}/>*/}
            {/*        <MenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true}/>*/}
            {/*    </MenuInnerWithSub>*/}
            {/*</MenuInnerWithSub>*/}

            {/*<MenuInnerWithSub title='Apps' to='/apps' menuPlacement='bottom-start' menuTrigger='click'>*/}
            {/*    /!* PAGES *!/*/}
            {/*    <MenuInnerWithSub*/}
            {/*        title='Chat'*/}
            {/*        to='/apps/chat'*/}
            {/*        icon='/media/icons/duotune/communication/com012.svg'*/}
            {/*        hasArrow={true}*/}
            {/*        menuPlacement='left-start'*/}
            {/*        menuTrigger={`{default:'click', lg: 'hover'}`}*/}
            {/*    >*/}
            {/*        <MenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true}/>*/}
            {/*        <MenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true}/>*/}
            {/*        <MenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true}/>*/}
            {/*    </MenuInnerWithSub>*/}
            {/*    <MenuItem*/}
            {/*        icon='/media/icons/duotune/general/gen051.svg'*/}
            {/*        to='/apps/user-management/users'*/}
            {/*        title='User management'*/}
            {/*    />*/}


            {/*</MenuInnerWithSub>*/}
            {/*<MenuInnerWithSub*/}
            {/*    isMega={true}*/}
            {/*    title='Mega menu'*/}
            {/*    to='/mega-menu'*/}
            {/*    menuPlacement='bottom-start'*/}
            {/*    menuTrigger='click'*/}
            {/*>*/}
            {/*    <MegaMenu/>*/}
            {/*</MenuInnerWithSub>*/}
            {/*<MenuItem title='کارمندان' to='/Costumers' />*/}
        </>
    )
}
